import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import frCommon from "@/locales/fr/common.json";
import frHome from "@/locales/fr/home.json";
import frAuth from "@/locales/fr/auth.json";
import frFaq from "@/locales/fr/faq.json";
import frLegal from "@/locales/fr/legal.json";
import frDashboard from "@/locales/fr/dashboard.json";
import frBoats from "@/locales/fr/boats.json";
import frMaintenance from "@/locales/fr/maintenance.json";
import frInventory from "@/locales/fr/inventory.json";
import frChecklists from "@/locales/fr/checklists.json";
import frAssistant from "@/locales/fr/assistant.json";
import frPorts from "@/locales/fr/ports.json";
import frAccount from "@/locales/fr/account.json";

import enCommon from "@/locales/en/common.json";
import enHome from "@/locales/en/home.json";
import enAuth from "@/locales/en/auth.json";
import enFaq from "@/locales/en/faq.json";
import enLegal from "@/locales/en/legal.json";
import enDashboard from "@/locales/en/dashboard.json";
import enBoats from "@/locales/en/boats.json";
import enMaintenance from "@/locales/en/maintenance.json";
import enInventory from "@/locales/en/inventory.json";
import enChecklists from "@/locales/en/checklists.json";
import enAssistant from "@/locales/en/assistant.json";
import enPorts from "@/locales/en/ports.json";
import enAccount from "@/locales/en/account.json";

export const SUPPORTED_LANGUAGES = ["fr", "en"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const NAMESPACES = [
  "common",
  "home",
  "auth",
  "faq",
  "legal",
  "dashboard",
  "boats",
  "maintenance",
  "inventory",
  "checklists",
  "assistant",
  "ports",
  "account",
];

export const resources = {
  fr: {
    common: frCommon,
    home: frHome,
    auth: frAuth,
    faq: frFaq,
    legal: frLegal,
    dashboard: frDashboard,
    boats: frBoats,
    maintenance: frMaintenance,
    inventory: frInventory,
    checklists: frChecklists,
    assistant: frAssistant,
    ports: frPorts,
    account: frAccount,
  },
  en: {
    common: enCommon,
    home: enHome,
    auth: enAuth,
    faq: enFaq,
    legal: enLegal,
    dashboard: enDashboard,
    boats: enBoats,
    maintenance: enMaintenance,
    inventory: enInventory,
    checklists: enChecklists,
    assistant: enAssistant,
    ports: enPorts,
    account: enAccount,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    defaultNS: "common",
    ns: NAMESPACES,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "nauticoach-lang",
      caches: ["localStorage"],
    },
  });

const applyHtmlLang = (lng: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng.startsWith("en") ? "en" : "fr";
  }
};

applyHtmlLang(i18n.language || "fr");
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
